import axios from 'axios'
import { deburr } from 'lodash'

import { i18n } from '@/i18n/i18n'

export const DeeplinkService = {
  async getAllTypes(): Promise<{ text: string; name: string }[]> {
    const { data } = await axios.get('/api/deeplink/types')
    return translateTypes(data)
  },
}

function translateTypes(
  types: DeeplinkType[],
): { text: string; name: string }[] {
  return types
    .map((target: DeeplinkType) => {
      const key = target.name.toUpperCase()
      // target-specific labels (e.g. webview vs browser) win over the generic element labels
      const targetKey = `DEEPLINK_COMPONENT.TARGET_LABEL.${key}`
      return {
        text: i18n.te(targetKey)
          ? i18n.tc(targetKey)
          : i18n.tc(`DEEPLINK_COMPONENT.LABEL.${key}`),
        name: target.name,
      }
    })
    .sort((s1, s2) => {
      return deburr(s1.text.toString()) < deburr(s2.text.toString()) ? -1 : 1
    })
}

export class DeeplinkType {
  name = ''
  hasParams = false
  constructor(name: string, hasParams = false) {
    this.name = name
    this.hasParams = hasParams
  }
}
